import React from 'react';
import { useTranslation } from 'react-i18next';
import './Footer.css';

const Footer = () => {
  const { t } = useTranslation();
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-left">
            <div className="contact-section">
              <h3 className="footer-title">{t('footer.fale')}</h3>
              <p className="footer-description">
                {t('footer.desc')}
              </p>
              <div className="contact-info">
                <div className="contact-item">
                  <strong>{t('footer.email')}</strong> contato@kitlumina.com.br
                </div>
                <div className="contact-item">
                  <strong>{t('footer.tel')}</strong> (51) 9.9521-5518
                </div>
                <div className="contact-item">
                  <strong>{t('footer.adr')}</strong> R. Almirante Tamandare, 20<br />Itajai / Sc
                </div>
              </div>
            </div>
            <div className="social-section">
              <h3 className="footer-title">{t('footer.sigalumina')}</h3>
              <div className="social-links">
                <a href="#instagram" className="social-link">Instagram</a>
                <a href="#tiktok" className="social-link">TikTok</a>
                <a href="#youtube" className="social-link">YouTube</a>
              </div>
            </div>
          </div>
          <div className="footer-right">
            <div className="product-image">
              <picture>
                <source type="image/webp" srcSet="/images/ban_05.webp" />
                <img 
                  src="/images/ban_05.png" 
                  alt="Embalagens Lumina" 
                />
              </picture>
            </div>
          </div>
        </div>
        <div className="footer-bottom">
          <p>{t('footer.copyright')}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;


